// src/components/DraggableWindow/WindowControls.js
import React, { useState, useRef, useEffect } from 'react';
import { X, Minus, Layout, Maximize2 } from "lucide-react";
import { SINGLE_WINDOW_LAYOUTS } from '../../utils/layoutManager';

const WindowControls = ({
  isMaximized,
  onMinimize,
  onMaximize,
  onClose,
  onLayoutSelect
}) => {
  const [isLayoutMenuOpen, setIsLayoutMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsLayoutMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="window-controls flex items-center space-x-1">
      <div className="relative" ref={menuRef}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsLayoutMenuOpen(!isLayoutMenuOpen);
          }}
          className="p-1 hover:bg-gray-300 rounded transition-colors"
          title="Layout"
        >
          <Layout size={14} />
        </button>

        {isLayoutMenuOpen && (
          <div className="absolute right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-1 w-40 z-50">
            {SINGLE_WINDOW_LAYOUTS.map(layout => (
              <button
                key={layout.name}
                onClick={() => {
                  onLayoutSelect(layout.name);
                  setIsLayoutMenuOpen(false);
                }}
                className="w-full px-3 py-1 text-left hover:bg-gray-100 flex items-center"
              >
                {layout.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={onMinimize}
        className="p-1 hover:bg-gray-300 rounded transition-colors"
        title="Minimize"
      >
        <Minus size={14} />
      </button>

      <button
        onClick={() => onMaximize({})}
        className="p-1 hover:bg-gray-300 rounded transition-colors"
        title="Fill Viewport"
      >
        <Maximize2 size={14} />
      </button>

      <button
        onClick={onClose}
        className="p-1 hover:bg-red-500 hover:text-white rounded transition-colors"
        title="Close"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default WindowControls;
